var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 -47 511.99998 511",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m427.023438 166.292969v128.84375c-18.445313 14.777343-38.328126 26.824219-59.121094 36.144531-5.171875 2.320312-10.398438 4.472656-15.675782 6.457031-41.21875 15.476563-85.355468 20.65625-128.519531 15.539063-49.46875-5.863282-97.65625-25.246094-138.722656-58.140625v-128.84375zm0 0",
    fill: "#545d68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3b454f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.847656 166.296875v174.664063c-29.789062-10-58.210937-25.277344-83.863281-45.820313v-128.84375zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.902344 193.585938v137.695312c-5.171875 2.320312-10.398438 4.472656-15.675782 6.457031v-144.152343c0-5.300782 3.511719-9.605469 7.839844-9.605469 4.324219 0 7.835938 4.304687 7.835938 9.605469zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.023438 166.292969v10.449219l-171.019532 65.199218-171.019531-65.199218v-10.449219zm0 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 98.101562v35.789063l-256 97.601563-256-97.601563v-35.789063l256-97.601562zm0 0",
    fill: "#545d68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 195.707031v35.785157l-256-97.601563v-35.789063zm0 0",
    fill: "#3b454f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m387.523438 380.65625c-4.328126 0-7.835938-3.511719-7.835938-7.839844v-222.199218l-126.921875-57.46875c-3.941406-1.785157-5.691406-6.429688-3.90625-10.375 1.785156-3.941407 6.425781-5.691407 10.375-3.90625l131.523437 59.554687c2.804688 1.269531 4.601563 4.0625 4.601563 7.136719v227.257812c0 4.328125-3.507813 7.839844-7.835937 7.839844zm0 0",
    fill: "#6198ce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m409.46875 394.761719c0 12.117187-9.824219 21.941406-21.941406 21.941406-12.121094 0-21.945313-9.824219-21.945313-21.941406 0-12.121094 9.824219-21.945313 21.945313-21.945313 12.117187 0 21.941406 9.824219 21.941406 21.945313zm0 0",
    fill: "#f7d360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.637b42268777fdce7dae3d3627bf7fbc.svg";
export { ForwardRef as ReactComponent };